const common = {
  // Nav
  nav_home: 'Главная',
  nav_about: 'О нас',
  nav_services: 'Услуги',
  nav_cases: 'Истории успеха',
  nav_knowledge: 'Знания',
  nav_contact: 'Контакты',
  nav_consult: 'Консультация',
  nav_switch_lang: 'Сменить язык',
  nav_service_overview: 'Обзор услуг',
  nav_service_ivf: 'ЭКО 3-го поколения',
  nav_service_surrogacy: 'Суррогатное материнство',
  nav_service_full: 'ЭКО + Суррогатное',

  // Hero
  hero_title1: 'ЭКО 3-го пок. · Суррогатное · Полный цикл',
  hero_title2: 'Центр репродукции в Кыргызстане',
  hero_subtitle: 'Три основные услуги, гибкие планы, от стимуляции до возвращения малыша домой — профессиональная забота на каждом этапе',
  hero_cta1: 'Бесплатная консультация',
  hero_cta2: 'Узнать подробнее',
  hero_stat1: 'Успешных случаев',
  hero_stat2: 'Специалистов',
  hero_stat3: 'Лет работы',
  hero_stat4: 'Сертификатов',
  hero_prev_slide: 'Предыдущий',
  hero_next_slide: 'Следующий',
  hero_slide_to: 'Перейти к слайду {{n}}',

  // Brand
  brand_name: 'Центр ЭКО и суррогатного материнства в Кыргызстане',
  brand_sub: 'Центр суррогатного материнства',

  // Services
  services_title: 'Наши услуги',
  services_subtitle: 'Комплексные услуги по вспомогательной репродукции — от медицинского планирования до юридической защиты',
  services_label: 'Наши услуги',
  service_surrogacy: 'Суррогатное материнство (Single)',
  service_surrogacy_desc: 'Услуга суррогатного материнства для клиентов с готовыми эмбрионами, строгий отбор суррогатных матерей, полное наблюдение',
  service_ivf: 'ЭКО 3-го поколения',
  service_ivf_desc: 'ЭКО с ПГТ-А генетическим скринингом, 8 эмбрионов за один цикл, высокий процент успеха',
  service_egg: 'ЭКО + Суррогатное',
  service_egg_desc: 'Полный комплекс ЭКО + суррогатное материнство, от стимуляции до возвращения малыша домой',
  service_legal: 'Юридическая поддержка',
  service_legal_desc: 'Законодательство Кыргызстана, гарантия родительских прав, оформление свидетельства о рождении',
  service_more: 'Подробнее',

  // WhyUs
  whyus_label: 'Почему мы',
  whyus_title: 'Почему выбирают нас',
  whyus_floating_label: 'успешных случаев, счастливые семьи по всему миру',
  whyus_legal: 'Законная защита',
  whyus_legal_desc: 'Суррогатное материнство легально в Кыргызстане, родительские права защищены законом',
  whyus_medical: 'Передовые медицинские ресурсы',
  whyus_medical_desc: 'Сотрудничество с ведущими клиниками, технологии ЭКО/ПГТ',
  whyus_global: 'Международное обслуживание',
  whyus_global_desc: 'Трёхъязычная команда (китайский/английский/русский), полная поддержка',
  whyus_transparent: 'Прозрачные цены',
  whyus_transparent_desc: 'Без скрытых платежей, детальная смета, комплексные пакеты',
  whyus_consultant: 'Личный консультант',
  whyus_consultant_desc: 'От первой консультации до рождения ребёнка — персональный консультант',
  whyus_experience: '10 лет опыта',
  whyus_experience_desc: 'Более 500 успешных случаев, богатый практический опыт',

  // Testimonials
  testimonials_label: 'Отзывы',
  testimonials_title: 'Отзывы клиентов',
  testimonial_name1: 'Г-жа Чжао и г-н Ван',
  testimonial_loc1: 'Пекин',
  testimonial_content1: 'От первой консультации до рождения ребёнка команда RTB была с нами на каждом шагу, даря тепло дома в чужой стране. Спасибо каждому сотруднику — вы помогли осуществить нашу многолетнюю мечту.',
  testimonial_service1: 'Суррогатное + ЭКО',
  testimonial_name2: 'Семья Ли',
  testimonial_loc2: 'Шанхай',
  testimonial_content2: 'Мы почти потеряли надежду после многих неудач ЭКО. Друг порекомендовал RTB. Консультант терпеливо проанализировал нашу ситуацию, разработал план ЭКО 3-го поколения, и первая же попытка удалась!',
  testimonial_service2: 'ЭКО 3-го поколения',
  testimonial_name3: 'Марина К.',
  testimonial_loc3: 'Москва',
  testimonial_content3: 'Команда RTB оказалась очень профессиональной и заботливой. Весь процесс прошёл гладко, и сейчас у нас есть наш долгожданный малыш.',
  testimonial_service3: 'ЭКО + Суррогатное',

  // Cases
  cases_title: 'Истории успеха',
  cases_subtitle: 'Каждый ребёнок — это чудо. Счастливые истории реальных семей',
  cases_view_all: 'Все истории',
  cases_share: 'Поделиться',
  cases_share_modal_title: 'Поделиться историей',
  cases_share_modal_desc: 'Делитесь любовью и надеждой, пусть больше семей узнают о нас',
  cases_cat_all: 'Все истории',
  cases_cat_surrogacy: 'Суррогатное',
  cases_cat_ivf: 'ЭКО 3-го поколения',
  cases_cat_full: 'ЭКО + Суррогатное',
  cases_filter_desc: 'Просмотр реальных семейных историй по типу услуги',
  cases_no_data: 'Нет историй в этой категории, попробуйте другую',
  cases_stats_stories: 'Успешных историй',
  cases_stats_countries: 'Стран',
  cases_stats_satisfaction: 'Удовлетворённость',
  cases_stats_years: 'Лет опыта',
  cases_cta_title: 'Ваша счастливая история начинается здесь',
  cases_cta_desc: 'Запишитесь на бесплатную консультацию и сделайте первый шаг к мечте',
  cases_page_sub: 'Реальные истории счастливых семей',
  cases_section_label: 'Истории успеха',

  // Knowledge
  knowledge_title: 'База знаний',
  knowledge_subtitle: 'Профессиональные медицинские знания для ответа на все ваши вопросы',
  knowledge_view_all: 'Все статьи',
  knowledge_cat_all: 'Все',
  knowledge_cat_guide: 'Руководства',
  knowledge_cat_medical: 'Медицина',
  knowledge_cat_faq: 'FAQ',
  knowledge_cat_legal: 'Законодательство',
  knowledge_read_full: 'Читать полностью',
  knowledge_related_title: 'Похожие статьи',
  knowledge_more_title: 'Больше статей',
  knowledge_share: 'Поделиться:',
  knowledge_not_found: 'Статья не найдена',
  knowledge_back: 'Вернуться в базу знаний',
  knowledge_loading: 'Загрузка...',
  knowledge_loading_articles: 'Загрузка статей...',
  knowledge_no_articles: 'Нет статей',
  knowledge_sidebar_tags: 'Популярные теги',
  knowledge_sidebar_stats: 'Статистика категорий',
  knowledge_sidebar_cta: 'Остались вопросы? Свяжитесь с нами',
  knowledge_sidebar_cta_desc: 'Профессиональные консультанты ответят на ваши вопросы в течение 24 часов, бесплатно',
  knowledge_sidebar_cta_btn: 'Бесплатная консультация',
  knowledge_tag_articles: 'статей',
  knowledge_tag_related: 'Все статьи по теме "{{tag}}"',
  knowledge_tag_view_all: 'Все статьи',
  knowledge_section_label: 'База знаний',
  knowledge_filter_placeholder: 'Поиск статей...',
  knowledge_current_tag_filter: 'Текущий фильтр по тегу:',
  knowledge_clear_filter: 'Сбросить фильтр',

  // FAQ
  faq_title: 'Часто задаваемые вопросы',
  faq_subtitle: 'Быстрые ответы на самые распространённые вопросы',
  faq_label: 'FAQ',
  faq_cat_all: 'Все',
  faq_cat_process: 'Процесс',
  faq_cat_medical: 'Медицина',
  faq_cat_legal: 'Законодательство',
  faq_cat_cost: 'Стоимость',
  faq_no_data: 'Нет вопросов',
  faq_load_error: 'Ошибка загрузки',

  // Appointment
  appt_title: 'Записаться на консультацию',
  appt_subtitle: 'Заполните форму, и наш специалист свяжется с вами в течение 24 часов',
  appt_name: 'Ваше имя',
  appt_phone: 'Телефон',
  appt_wechat: 'WeChat ID',
  appt_email: 'Электронная почта',
  appt_service: 'Интересующая услуга',
  appt_message: 'Дополнительная информация',
  appt_submit: 'Записаться',
  appt_success: 'Запись успешна! Мы свяжемся с вами в ближайшее время.',
  appt_service_opt1: 'Суррогатное материнство',
  appt_service_opt2: 'ЭКО 3-го поколения',
  appt_service_opt3: 'ЭКО + Суррогатное',
  appt_service_opt4: 'Общая консультация',
  appt_label: 'Бесплатная консультация',
  appt_form_title: 'Запись на консультацию',
  appt_form_desc: 'Заполните данные, консультант свяжется в течение 24 часов',
  appt_form_privacy: 'Строгая защита конфиденциальности',
  appt_form_wechat_hint: 'Или добавьте WeChat: 16600032397',
  appt_form_name_placeholder: 'Введите ваше имя',
  appt_form_phone_placeholder: '+86 или международный номер',
  appt_form_wechat_placeholder: 'WeChat ID (необязательно)',
  appt_form_email_placeholder: 'email@example.com (необязательно)',
  appt_form_service_placeholder: 'Выберите услугу',
  appt_form_message_placeholder: 'Опишите вашу ситуацию (возраст, предыдущие анализы, опыт ЭКО и т.д.), максимум 500 знаков',
  appt_form_contact_soon: 'Мы свяжемся с вами в течение 24 часов, пожалуйста, держите телефон включённым',

  // Contact
  contact_title: 'Свяжитесь с нами',
  contact_subtitle: 'Мы всегда рады помочь вам',
  contact_phone: 'Телефон',
  contact_wechat: 'WeChat',
  contact_email: 'Эл. почта',
  contact_address: 'Адрес офиса',
  contact_scan_wechat: 'Сканировать для WeChat',
  contact_scan_whatsapp: 'Сканировать для WhatsApp',
  contact_online: 'Онлайн-чат',
  contact_label: 'Контакты',
  contact_info_title: 'Контактная информация',
  contact_qr_title: 'Сканируйте для связи',
  contact_wechat_click: '(Нажмите для просмотра QR-кода)',
  contact_form_title: 'Онлайн-консультация',
  contact_form_desc: 'Заполните форму, консультант свяжется с вами в течение 24 часов',
  contact_form_privacy: 'Мы обязуемся защищать вашу конфиденциальность',
  contact_map_title: 'Расположение офиса',
  contact_map_title_attr: 'Расположение офиса в Бишкеке, Кыргызстан',

  // CTA Banner
  cta_label: 'Бесплатная консультация · 免费咨询',
  cta_title1: 'Начните свой путь к родительству',
  cta_title2: 'Консультант ответит в течение 24 часов',
  cta_desc: 'Где бы вы ни находились, наша профессиональная команда всегда готова помочь. От первой консультации до рождения ребёнка — мы с вами на каждом шагу.',
  cta_btn1: 'Бесплатная консультация',
  cta_btn2: 'Смотреть истории успеха',
  cta_badge1: 'Законное суррогатное материнство',
  cta_badge2: 'Строгая конфиденциальность',
  cta_badge3: 'Трёхъязычный сервис',
  cta_badge4: 'Личный консультант',

  // Footer
  footer_rights: '© 2026 Центр ЭКО и суррогатного материнства в Кыргызстане. Все права защищены.',
  footer_privacy: 'Политика конфиденциальности',
  footer_terms: 'Условия использования',
  footer_desc: 'Профессиональные услуги ЭКО и суррогатного материнства в Кыргызстане.',
  footer_quick_links: 'Быстрые ссылки',
  footer_contact: 'Контакты',
  footer_scan: 'Сканируйте для связи',
  footer_phone: '+86 16600032397',
  footer_email: 'ivfjason@gmail.com',
  footer_address: 'Бишкек, Кыргызстан',
  footer_wechat_label: 'WeChat',
  footer_whatsapp_label: 'WhatsApp',

  // About
  about_title: 'О нас',
  about_subtitle: 'Десять лет помогаем каждой семье осуществить мечту',
  about_desc1: 'Центр ЭКО и суррогатного материнства в Кыргызстане основан в 2014 году. Мы специализируемся на вспомогательной репродукции в Центральной Азии и предоставляем безопасные, законные и эффективные решения для будущих родителей со всего мира.',
  about_desc2: 'Законодательство Кыргызстана прямо защищает родительские права заказчиков, что делает страну одной из немногих с открытой и полностью регулируемой системой суррогатного материнства.',
  about_mission: 'Наша миссия',
  about_mission_desc: 'Помочь каждой семье, мечтающей о ребёнке, воплотить эту мечту в жизнь с профессионализмом и заботой.',

  // Services page
  svc_intro: 'Комплексные услуги по вспомогательной репродукции — от медицинского планирования до юридической защиты',
  svc_ivf_title: 'ЭКО 3-го поколения',
  svc_ivf_subtitle: 'ПГТ-А ЭКО третьего поколения',
  svc_ivf_desc: 'Пакет ЭКО 3-го поколения на один цикл, включая консультацию специалиста, стимуляцию, забор яйцеклеток, ИКСИ, культивирование 5-7 дней, биопсию, скрининг ПГТ-А (8 эмбрионов), один перенос, 1 год криоконсервации.',
  svc_surrogacy_title: 'Суррогатное материнство',
  svc_surrogacy_subtitle: 'Услуга для клиентов с готовыми эмбрионами',
  svc_surrogacy_desc: 'Эксклюзивное суррогатное материнство для клиентов с готовыми эмбрионами. Включает отбор суррогатной матери, анализ крови на беременность, ежемесячные осмотры, компенсацию, 1 год хранения эмбрионов, полное наблюдение, роды в лицензированной клинике, свидетельство о рождении, ДНК-тест, репатриацию.',
  svc_full_title: 'ЭКО + Суррогатное',
  svc_full_subtitle: 'Полный комплекс ЭКО + суррогатное материнство',
  svc_full_desc: 'Полный цикл от стимуляции до возвращения ребёнка домой. Три плана: Эконом, Премиум и Комплексный для разных потребностей и бюджетов.',
  svc_cta_title: 'Не уверены, какой план подходит?',
  svc_cta_desc: 'Свяжитесь с нашими консультантами для бесплатной персональной рекомендации',
  svc_section_label: 'Услуги',

  // IVF detail page
  ivf_breadcrumb_svc: 'Услуги',
  ivf_breadcrumb: 'ЭКО 3-го поколения (ПГТ-А)',
  ivf_label: 'ЭКО третьего поколения',
  ivf_page_title: 'ЭКО 3-го поколения (ПГТ-А)',
  ivf_hero_desc: 'Пакет ЭКО 3-го поколения на один цикл, включая культивирование всех эмбрионов, биопсию, скрининг ПГТ-А (8 эмбрионов), ИКСИ и 1 год криоконсервации.',
  ivf_cta_consult: 'Бесплатная консультация',
  ivf_cta_whatsapp: 'WhatsApp',
  ivf_stat_price: 'Стоимость цикла',
  ivf_stat_screen: 'Скрининг ПГТ-А',
  ivf_stat_rate: 'Успех до 35 лет',
  ivf_stat_freeze: 'Хранение эмбрионов',
  ivf_process_title: 'Полный процесс ЭКО',
  ivf_process_sub: 'Восемь шагов с профессиональной медицинской поддержкой на каждом этапе',
  ivf_process_label: 'Полный процесс ЭКО',
  ivf_included_title: 'Что включено',
  ivf_included_sub: 'Детали пакета ЭКО 3-го поколения за $19,000',
  ivf_extra_title: 'Дополнительные расходы',
  ivf_extra_sub: 'Распространённые дополнительные расходы, взимаются по необходимости',
  ivf_cta_title: 'Начните ваш путь ЭКО 3-го поколения',
  ivf_cta_desc: 'Профессиональный медицинский консультант ответит на вопросы и поможет разработать лучший план',

  // IVF steps
  ivf_step1_title: 'План и оценка',
  ivf_step1_dur: 'Неделя 1-2',
  ivf_step1_desc: 'Удалённая и местная консультация специалиста, комплексная оценка фертильности обоих партнёров. Включая овариальный резерв (АМГ/КАФ), анализ спермы, оценку матки, кариотипирование.',
  ivf_step1_p1: 'Удалённая + местная консультация',
  ivf_step1_p2: 'Тестирование АМГ/КАФ',
  ivf_step1_p3: 'Анализ и морфология спермы',
  ivf_step1_p4: 'Кариотипирование',
  ivf_step2_title: 'Контролируемая стимуляция',
  ivf_step2_dur: 'Неделя 2-4',
  ivf_step2_desc: 'Персонализированный протокол стимуляции с ежедневными инъекциями гонадотропинов для развития множественных фолликулов. Тщательный мониторинг роста фолликулов.',
  ivf_step2_p1: 'Персонализированный протокол',
  ivf_step2_p2: 'Непрерывный УЗИ-мониторинг',
  ivf_step2_p3: 'Динамическое тестирование гормонов',
  ivf_step2_p4: 'Своевременная корректировка',
  ivf_step3_title: 'Забор яйцеклеток',
  ivf_step3_dur: 'Неделя 4-5',
  ivf_step3_desc: 'При достижении зрелости фолликулов (18-22 мм) вводится триггер ХГЧ, через 36 часов — трансвагинальный забор под внутривенной седацией, около 20-30 минут.',
  ivf_step3_p1: 'Безболезненный забор под седацией',
  ivf_step3_p2: 'Точное УЗИ-наведение',
  ivf_step3_p3: 'Опытный врач',
  ivf_step3_p4: 'Восстановление в тот же день',
  ivf_step4_title: 'Подготовка спермы и ИКСИ',
  ivf_step4_dur: 'В день забора',
  ivf_step4_desc: 'Сперма собирается в день забора, обрабатывается центрифугированием в градиенте плотности для отбора оптимальных сперматозоидов. ИКСИ вводит один сперматозоид в каждый ооцит.',
  ivf_step4_p1: 'Отбор сперматозоидов',
  ivf_step4_p2: 'ИКСИ инъекция',
  ivf_step4_p3: 'Оценка подвижности',
  ivf_step4_p4: 'Резерв замороженной спермы',
  ivf_step5_title: 'Культивирование эмбрионов',
  ivf_step5_dur: 'День 5-10',
  ivf_step5_desc: 'Оплодотворённые яйцеклетки культивируются 5-7 дней до стадии бластоцисты. Цейтраферная съёмка мониторит развитие непрерывно.',
  ivf_step5_p1: 'Передовые питательные среды',
  ivf_step5_p2: 'Цейтраферный мониторинг',
  ivf_step5_p3: 'Все эмбрионы до бластоцисты',
  ivf_step5_p4: 'Оценка по шкале Гарднера',
  ivf_step6_title: 'Генетический скрининг ПГТ-А',
  ivf_step6_dur: 'День 10-30',
  ivf_step6_desc: 'Биопсия всех бластоцист для скрининга ПГТ-А на хромосомную эуплоидию. Пакет включает скрининг 8 эмбрионов, дополнительно $550/эмбрион.',
  ivf_step6_p1: 'Биопсия всех эмбрионов',
  ivf_step6_p2: 'Скрининг хромосомной эуплоидии',
  ivf_step6_p3: 'Пакет: 8 эмбрионов',
  ivf_step6_p4: 'ПГТ-М опционально',
  ivf_step7_title: 'Перенос эмбриона',
  ivf_step7_dur: 'Цикл 2-5 после менструации',
  ivf_step7_desc: 'Эмбрион наивысшего качества переносится через мягкий катетер под УЗИ-контролем, без анестезии, около 5-10 минут.',
  ivf_step7_p1: 'Неинвазивный мягкий катетер',
  ivf_step7_p2: 'УЗИ-контроль в реальном времени',
  ivf_step7_p3: 'Один перенос за цикл',
  ivf_step7_p4: 'Анализ ХГЧ через 14 дней',
  ivf_step8_title: 'Тест на беременность',
  ivf_step8_dur: '2-8 недель после переноса',
  ivf_step8_desc: 'Анализ крови на ХГЧ через 14 дней после переноса. Непрерывный мониторинг ХГЧ и прогестерона, УЗИ на 5-6 неделе для подтверждения беременности и сердцебиения.',
  ivf_step8_p1: 'Точный анализ ХГЧ',
  ivf_step8_p2: 'УЗИ подтверждение сердцебиения',
  ivf_step8_p3: 'Корректировка поддержки',
  ivf_step8_p4: 'Тщательное наблюдение',

  // IVF included items
  ivf_item1_title: 'Консультация специалиста',
  ivf_item1_desc: 'Удалённая и местная консультация, координация двух больниц для плана стимуляции.',
  ivf_item2_title: 'Цейтраферный мониторинг',
  ivf_item2_desc: 'Передовой цейтраферный инкубатор, круглосуточный мониторинг развития эмбрионов.',
  ivf_item3_title: 'Оценка анализов',
  ivf_item3_desc: 'Предцикловая оценка всех необходимых анализов, персонализированный протокол.',
  ivf_item4_title: 'Стимуляция и забор',
  ivf_item4_desc: 'Одна стимуляция и один забор, безболезненная процедура под седацией с УЗИ-наведением.',
  ivf_item5_title: 'ИКСИ',
  ivf_item5_desc: 'Микроманипуляция для введения одного сперматозоида в каждый ооцит.',
  ivf_item6_title: 'Культивирование эмбрионов',
  ivf_item6_desc: 'Все эмбрионы культивируются 5-7 дней до стадии бластоцисты.',
  ivf_item7_title: 'Биопсия эмбрионов',
  ivf_item7_desc: 'Биопсия трофэктодермы всех бластоцист для сбора образцов ПГТ-А.',
  ivf_item8_title: 'ПГТ-А скрининг (8 эмбрионов)',
  ivf_item8_desc: 'Скрининг 8 эмбрионов на хромосомную эуплоидию, $550/доп. эмбрион.',
  ivf_item9_title: 'Один перенос эмбриона',
  ivf_item9_desc: 'Один перенос за цикл, УЗИ-контроль, точная имплантация.',
  ivf_item10_title: 'Криоконсервация 1 год',
  ivf_item10_desc: 'Оставшиеся эмбрионы витрифицированы на 1 год, выживаемость 99%+.',
  ivf_item11_title: 'Местный сервис в Кыргызстане',
  ivf_item11_desc: 'Медицинский переводчик, трансфер из аэропорта, транспорт до больницы.',
  ivf_item12_title: 'Бытовые принадлежности',
  ivf_item12_desc: '2 сим-карты, 1 адаптер питания, помощь с бронью квартиры/отеля.',

  // IVF extra costs
  ivf_extra1_title: 'Абдоминальный забор',
  ivf_extra1_price: 'Уточняется',
  ivf_extra1_desc: 'Когда трансвагинальный забор невозможен',
  ivf_extra2_title: 'Доп. ПГТ-А',
  ivf_extra2_price: '$550/эмбрион',
  ivf_extra2_desc: 'Сверх 8 эмбрионов в пакете',
  ivf_extra3_title: 'ПГТ-М скрининг',
  ivf_extra3_price: '$800/эмбрион',
  ivf_extra3_desc: 'Скрининг моногенных заболеваний',
  ivf_extra4_title: 'Вторая стимуляция',
  ivf_extra4_price: '$14,000/цикл',
  ivf_extra4_desc: 'Включая скрининг ПГТ-А 8 эмбрионов',
  ivf_extra5_title: 'Донорские гаметы',
  ivf_extra5_price: 'По запросу',
  ivf_extra5_desc: 'КГ/КЗ/РФ международные доноры',
  ivf_extra6_title: 'Биохимическая сепарация',
  ivf_extra6_price: '$700',
  ivf_extra6_desc: 'Дополнительная обработка спермы',
  ivf_extra7_title: 'TESE',
  ivf_extra7_price: 'Уточняется',
  ivf_extra7_desc: 'При затруднённой эякуляции',
  ivf_extra8_title: 'Электронная виза',
  ivf_extra8_price: 'По курсу',
  ivf_extra8_desc: 'Электронная виза Кыргызстана',
  ivf_extra9_title: 'Авиабилеты',
  ivf_extra9_price: 'По факту',
  ivf_extra9_desc: 'Зависит от рыночных цен',
  ivf_extra10_title: 'Инъекции на дому (стимуляция)',
  ivf_extra10_price: 'Самостоятельно',
  ivf_extra10_desc: 'Инъекции во время стимуляции',
  ivf_extra11_title: 'Инъекции после переноса',
  ivf_extra11_price: 'Самостоятельно',
  ivf_extra11_desc: 'Поддержка лютеиновой фазы',
  ivf_extra12_title: 'Препараты после беременности',
  ivf_extra12_price: 'Самостоятельно',
  ivf_extra12_desc: 'Медикаменты для поддержки беременности',

  // Surrogacy detail page
  scy_breadcrumb: 'Суррогатное материнство',
  scy_label: 'Суррогатное материнство',
  scy_page_title: 'Суррогатное материнство',
  scy_hero_desc: 'Эксклюзивное суррогатное материнство для клиентов с готовыми эмбрионами. От отбора суррогатной матери до репатриации ребёнка.',
  scy_stat_price1: 'Эконом от',
  scy_stat_price2: 'Премиум от',
  scy_stat_cases: 'Успешных случаев',
  scy_stat_legal: 'Юридическая защита',
  scy_process_title: 'Полный процесс суррогатного материнства',
  scy_process_sub: 'От первой консультации до репатриации ребёнка, полная прозрачность',
  scy_process_label: 'Полный процесс',
  scy_included_title: 'Что включено',
  scy_included_sub: 'Детали пакета суррогатного материнства (Эконом/Премиум)',
  scy_extra_title: 'Дополнительные расходы',
  scy_extra_sub: 'Распространённые дополнительные расходы, взимаются по необходимости',
  scy_plan_title: 'Сравнение планов',
  scy_plan_sub: 'Выберите лучший план для ваших потребностей и бюджета',
  scy_plan_label: 'Тарифы',
  scy_plan_note_title: 'Примечания и включения',
  scy_plan_inc_title: 'Обычно включено:',
  scy_plan_extra_title: 'Возможные доп. расходы:',
  scy_plan_note: '* Справочные диапазоны. Фактическая стоимость зависит от выбора плана, медицинских условий и обменных курсов. Свяжитесь с консультантом для точной персональной сметы.',
  scy_plan_economy: 'Эконом',
  scy_plan_economy_badge: 'Бюджетный выбор',
  scy_plan_economy_desc: 'Для клиентов с простым процессом',
  scy_plan_premium: 'Премиум',
  scy_plan_premium_badge: 'Самый популярный',
  scy_plan_premium_desc: 'Включает компенсацию рисков, более распределённые платежи',
  scy_plan_btn: 'Получить детальную смету',
  scy_cta_title: 'Готовы начать путь к родительству?',
  scy_cta_desc: 'Запишитесь на бесплатную консультацию. Ваш персональный консультант ответит на все вопросы',

  // Surrogacy steps
  scy_step1_title: 'Бесплатная консультация',
  scy_step1_dur: 'Неделя 1-2',
  scy_step1_desc: 'Свяжитесь с профессиональным консультантом RTB для бесплатной видео- или телефонной консультации. Консультант изучит ваши потребности, имеющиеся эмбрионы, бюджет и порекомендует подходящий план.',
  scy_step1_p1: 'Персональный консультант',
  scy_step1_p2: 'Оценка имеющихся эмбрионов',
  scy_step1_p3: 'Прозрачное объяснение плана и стоимости',
  scy_step1_p4: 'Подписание договора',
  scy_step2_title: 'Подбор суррогатной матери',
  scy_step2_dur: 'Месяц 1-3',
  scy_step2_desc: 'Подбор из базы кандидатов, прошедших строгий медицинский скрининг. Кандидаты проходят тройную сертификацию здоровья и психологическую оценку. Вы можете просмотреть профили и подтвердить выбор.',
  scy_step2_p1: 'Сотни кандидатов',
  scy_step2_p2: 'Тройная сертификация здоровья',
  scy_step2_p3: 'Психологическая оценка',
  scy_step2_p4: 'Комплексный подбор',
  scy_step3_title: 'Медицинское обследование',
  scy_step3_dur: 'Неделя 2-4',
  scy_step3_desc: 'Суррогатная мать проходит полное медицинское обследование: анализы крови, скрининг инфекций, гинекологический осмотр. Одновременно оценивается качество эмбрионов, определяется протокол переноса.',
  scy_step3_p1: 'Полное медицинское обследование',
  scy_step3_p2: 'Анализы крови и скрининг инфекций',
  scy_step3_p3: 'Оценка качества эмбрионов',
  scy_step3_p4: 'Разработка протокола переноса',
  scy_step4_title: 'Перенос эмбриона',
  scy_step4_dur: 'Месяц 3-4',
  scy_step4_desc: 'Эмбрион наивысшего качества переносится в матку суррогатной матери через мягкий катетер под УЗИ-контролем. Пакет включает один перенос. Анализ крови на беременность через 14 дней.',
  scy_step4_p1: 'Точный перенос под УЗИ-контролем',
  scy_step4_p2: 'Один перенос эмбриона',
  scy_step4_p3: 'Анализ крови через 14 дней',
  scy_step4_p4: 'Протокол лютеиновой поддержки',
  scy_step5_title: 'Полное наблюдение беременности',
  scy_step5_dur: 'Месяц 4-9',
  scy_step5_desc: 'На протяжении всей беременности медицинская команда следит за здоровьем суррогатной матери, ежемесячные осмотры, синхронизация отчётов, видеозвонки — вы всегда в курсе развития малыша.',
  scy_step5_p1: 'Ежемесячная синхронизация отчётов',
  scy_step5_p2: 'Медицинская поддержка 24/7',
  scy_step5_p3: 'Компенсация суррогатной матери',
  scy_step5_p4: 'Питание и психологическая забота',
  scy_step6_title: 'Рождение ребёнка',
  scy_step6_dur: 'Около даты родов',
  scy_step6_desc: 'Ребёнок рождается в лицензированном роддоме. Персональное сопровождение во время родов, профессиональный уход за новорождённым. Родители-заказчики регистрируются как законные родители в свидетельстве о рождении.',
  scy_step6_p1: 'Лицензированный роддом, естественные роды',
  scy_step6_p2: 'Родители регистрируются напрямую',
  scy_step6_p3: 'Профессиональный уход за новорождённым',
  scy_step6_p4: 'Полное сопровождение родов',
  scy_step7_title: 'Документы и возвращение домой',
  scy_step7_dur: '1-2 месяца после родов',
  scy_step7_desc: 'Помощь в ДНК-тестировании, свидетельстве о рождении, апостиле Гааги, визе и разрешении на выезд — полная поддержка для возвращения ребёнка домой.',
  scy_step7_p1: 'ДНК-тест на отцовство',
  scy_step7_p2: 'Свидетельство + апостиль',
  scy_step7_p3: 'Паспорт/виза',
  scy_step7_p4: 'Полная поддержка репатриации',
  // Surrogacy included items
  scy_item1_title: 'Отбор и обследование сурматери',
  scy_item1_desc: 'Строгий отбор и необходимое медицинское обследование, тройная сертификация для обеспечения здоровья.',
  scy_item2_title: 'Анализ крови на беременность',
  scy_item2_desc: 'Чувствительный анализ крови для подтверждения беременности через 14 дней после переноса.',
  scy_item3_title: 'Ежемесячные осмотры',
  scy_item3_desc: 'Ежемесячные необходимые осмотры сурматери, интерпретация отчётов, медицинская команда 24/7.',
  scy_item4_title: 'Компенсация сурматери',
  scy_item4_desc: 'Включая одежду, проживание, питание и компенсацию для обеспечения качества жизни во время беременности.',
  scy_item5_title: 'Криоконсервация 1 год',
  scy_item5_desc: 'Оставшиеся эмбрионы витрифицированы на 1 год, выживаемость 99%+, готовы к разморозке.',
  scy_item6_title: 'Координация видеозвонков',
  scy_item6_desc: 'Организация видеозвонков с сурматерью, чтобы вы всегда были в курсе развития малыша.',
  scy_item7_title: 'Сопровождение родов',
  scy_item7_desc: 'Персональное сопровождение во время родов, лицензированный роддом, профессиональный уход за новорождённым.',
  scy_item8_title: 'Свидетельство о рождении',
  scy_item8_desc: 'Помощь в оформлении медицинского свидетельства о рождении, родители-заказчики регистрируются как законные родители.',
  scy_item9_title: 'ДНК-тест на отцовство',
  scy_item9_desc: 'Помощь в проведении ДНК-теста для подтверждения родства, юридическое основание для репатриации.',
  scy_item10_title: 'Репатриация новорождённого',
  scy_item10_desc: 'Помощь в оформлении визы, разрешения на выезд и всех процедур для возвращения домой.',
  scy_item11_title: 'Местный сервис в Кыргызстане',
  scy_item11_desc: 'Медицинский переводчик, трансфер из аэропорта, транспорт до больницы.',
  scy_item12_title: 'Бытовые принадлежности',
  scy_item12_desc: '2 сим-карты, 1 адаптер питания, помощь с бронью квартиры/отеля.',
  // Surrogacy extra costs
  scy_extra1_title: 'Второй перенос',
  scy_extra1_price: '$3,000',
  scy_extra1_desc: 'Включая обследование и лекарства, при неудаче первого переноса',
  scy_extra2_title: 'Замена сурматери',
  scy_extra2_price: '$4,000/раз',
  scy_extra2_desc: 'Замена суррогатной матери в особых случаях',
  scy_extra3_title: 'Транспортировка эмбрионов',
  scy_extra3_price: '$12,000/раз',
  scy_extra3_desc: 'Стоимость международной транспортировки эмбрионов',
  scy_extra4_title: 'Компенсация за двойню',
  scy_extra4_price: '$12,000',
  scy_extra4_desc: 'Дополнительная компенсация за двойню',
  scy_extra5_title: 'Естественное разделение',
  scy_extra5_price: '$12,000',
  scy_extra5_desc: 'Компенсация при естественном разделении эмбриона на двойню',
  scy_extra6_title: 'Кесарево сечение',
  scy_extra6_price: '$4,000/раз',
  scy_extra6_desc: 'Дополнительная компенсация за кесарево сечение',
  scy_extra7_title: 'Электронная виза',
  scy_extra7_price: 'По курсу',
  scy_extra7_desc: 'Электронная виза Кыргызстана',
  scy_extra8_title: 'Авиабилеты',
  scy_extra8_price: 'По курсу',
  scy_extra8_desc: 'Стоимость авиабилетов по факту',
  scy_extra9_title: 'Сохранение беременности',
  scy_extra9_price: 'По факту',
  scy_extra9_desc: 'Лекарства и лечение для сохранения беременности',
  scy_extra10_title: 'Кувез для недоношенных',
  scy_extra10_price: 'Зависит от больницы',
  scy_extra10_desc: 'Стоимость кувеза для недоношенных новорождённых',
  scy_extra11_title: 'Няня',
  scy_extra11_price: '~$1,500/мес',
  scy_extra11_desc: 'Стоимость найма няни',
  scy_extra12_title: 'Апостиль Гааги',
  scy_extra12_price: 'По факту',
  scy_extra12_desc: 'Услуги апостиля и нотариуса',
  // Surrogacy plan items
  scy_plan_economy_item1: 'Отбор и обследование сурматери',
  scy_plan_economy_item2: 'Анализ крови на беременность',
  scy_plan_economy_item3: 'Ежемесячные осмотры',
  scy_plan_economy_item4: 'Компенсация сурматери',
  scy_plan_economy_item5: 'Криоконсервация эмбрионов 1 год',
  scy_plan_economy_item6: 'Лицензированный роддом, естественные роды',
  scy_plan_economy_item7: 'Оформление свидетельства о рождении',
  scy_plan_economy_item8: 'Помощь в ДНК-тестировании',
  scy_plan_economy_item9: 'Помощь в репатриации',
  scy_plan_economy_item10: 'Полная помощь с апостилем',
  scy_plan_economy_item11: 'Переводчик + трансфер из аэропорта',
  scy_plan_premium_item1: 'Всё содержимое плана Эконом',
  scy_plan_premium_item2: 'Компенсация рисков беременности',
  scy_plan_premium_item3: 'Персональное сопровождение родов',
  scy_plan_premium_item4: 'Интерпретация всех отчётов',
  scy_plan_premium_item5: 'Помощь с послеродовыми документами',
  scy_plan_premium_item6: 'Помощь с визой для возвращения',
  scy_plan_premium_item7: 'Более распределённые платежи',
  scy_plan_premium_item8: 'Меньше давление разовых платежей',
  scy_plan_premium_item9: 'VIP медицинский консультант',
  scy_plan_premium_item10: 'Психологическая поддержка',
  scy_plan_premium_item11: 'Экстренный медицинский план',
  // Surrogacy plan note items
  scy_plan_inc_item1: 'Скрининг здоровья и управление сурматерью',
  scy_plan_inc_item2: 'Медицинская стоимость одного переноса',
  scy_plan_inc_item3: 'Полное медицинское наблюдение беременности',
  scy_plan_inc_item4: 'Стоимость естественных родов в лицензированном роддоме',
  scy_plan_inc_item5: 'Оформление юридических документов о рождении',
  scy_plan_inc_item6: 'Помощь в ДНК-тестировании',
  scy_plan_inc_item7: 'Полное обслуживание китайским консультантом',
  scy_plan_extra_item1: 'Перелёт и проживание заказчика в Кыргызстане',
  scy_plan_extra_item2: 'Оформление китайского паспорта и прописки',
  scy_plan_extra_item3: 'Стоимость второго переноса',
  scy_plan_extra_item4: 'Стоимость сохранения беременности',
  scy_plan_extra_item5: 'Стоимость няни',
  scy_plan_extra_item6: 'Дополнительная компенсация за двойню',

  // Full service detail page
  full_breadcrumb: 'ЭКО + Суррогатное',
  full_label: 'ЭКО + Суррогатное',
  full_page_title: 'ЭКО + Суррогатное',
  full_hero_desc: 'Полный цикл от стимуляции до возвращения ребёнка домой. Три плана: Эконом/Премиум/Комплексный, полный процесс ЭКО + суррогатное материнство.',
  full_stat_price: 'Эконом от',
  full_stat_plans: 'Гибкие планы',
  full_stat_steps: 'Полный сервис',
  full_stat_legal: 'Юридическая защита',
  full_process_title: 'Полный процесс ЭКО + суррогатное материнство',
  full_process_sub: 'От стимуляции до репатриации ребёнка, полный цикл обслуживания',
  full_process_label: 'Полный процесс',
  full_cta_title: 'Начните путь ЭКО + суррогатное материнство',
  full_cta_desc: 'Профессиональный консультант предоставит бесплатную консультацию и порекомендует лучший план',
  // Fertility steps
  full_step1_title: 'План и оценка',
  full_step1_dur: 'Неделя 1-2',
  full_step1_desc: 'Удалённая консультация специалиста, комплексная оценка фертильности. Включая АМГ/КАФ, анализ спермы, оценку матки, кариотипирование и персонализированный план.',
  full_step1_p1: 'Удалённая + местная консультация',
  full_step1_p2: 'Тестирование АМГ/КАФ',
  full_step1_p3: 'Анализ и морфология спермы',
  full_step1_p4: 'Кариотипирование',
  full_step2_title: 'Контролируемая стимуляция',
  full_step2_dur: 'Неделя 2-4',
  full_step2_desc: 'Персонализированный протокол стимуляции с ежедневными инъекциями гонадотропинов. Тщательный мониторинг роста фолликулов.',
  full_step2_p1: 'Персонализированный протокол',
  full_step2_p2: 'Непрерывный УЗИ-мониторинг',
  full_step2_p3: 'Динамическое тестирование гормонов',
  full_step2_p4: 'Своевременная корректировка',
  full_step3_title: 'Забор яйцеклеток',
  full_step3_dur: 'Неделя 4-5',
  full_step3_desc: 'При созревании фолликулов — трансвагинальный забор под внутривенной седацией, около 20-30 минут. Возможен абдоминальный забор.',
  full_step3_p1: 'Безболезненный забор под седацией',
  full_step3_p2: 'Точное УЗИ-наведение',
  full_step3_p3: 'Опытный врач',
  full_step3_p4: 'Отдых в тот же день',
  full_step4_title: 'ИКСИ и культивирование',
  full_step4_dur: 'День 5-10',
  full_step4_desc: 'ИКСИ — инъекция одного сперматозоида в каждый ооцит. Культивирование 5-7 дней до бластоцисты с цейтраферным мониторингом.',
  full_step4_p1: 'ИКСИ инъекция',
  full_step4_p2: 'Все эмбрионы до бластоцисты',
  full_step4_p3: 'Цейтраферный мониторинг',
  full_step4_p4: 'Шкала Гарднера',
  full_step5_title: 'Генетический скрининг ПГТ-А',
  full_step5_dur: 'День 10-30',
  full_step5_desc: 'Биопсия всех бластоцист для ПГТ-А. Планы Эконом/Премиум включают скрининг 8 эмбрионов, Комплексный — многоцикловый ПГТ-А.',
  full_step5_p1: 'Биопсия всех эмбрионов',
  full_step5_p2: 'Скрининг хромосом',
  full_step5_p3: '8 эмбрионов в пакете',
  full_step5_p4: 'ПГТ-М опционально',
  full_step6_title: 'Перенос эмбриона',
  full_step6_dur: 'Неделя 11-14',
  full_step6_desc: 'Лучший эмбрион переносится суррогатной матери. Эконом — один перенос, Премиум/Комплексный — неограниченно. Анализ ХГЧ через 14 дней.',
  full_step6_p1: 'Точный перенос под УЗИ',
  full_step6_p2: 'Эконом 1x / Премиум и Комплексный неограниченно',
  full_step6_p3: 'Анализ ХГЧ через 14 дней',
  full_step6_p4: 'Протокол лютеиновой поддержки',
  full_step7_title: 'Полное наблюдение беременности',
  full_step7_dur: 'Неделя 15-40',
  full_step7_desc: 'Медицинская команда следит за здоровьем сурматери, ежемесячные осмотры, синхронизация отчётов, видеозвонки, компенсация рисков.',
  full_step7_p1: 'Ежемесячная синхронизация отчётов',
  full_step7_p2: 'Компенсация сурматери',
  full_step7_p3: 'Компенсация рисков беременности',
  full_step7_p4: 'Медицинская поддержка 24/7',
  full_step8_title: 'Рождение ребёнка',
  full_step8_dur: 'Около даты родов',
  full_step8_desc: 'Ребёнок рождается в лицензированном роддоме с персональным сопровождением. Родители регистрируются как законные родители, помощь с документами.',
  full_step8_p1: 'Лицензированный роддом, естественные роды',
  full_step8_p2: 'Родители регистрируются напрямую',
  full_step8_p3: 'Профессиональный уход за новорождённым',
  full_step8_p4: 'Полное сопровождение родов',
  full_step9_title: 'Документы и возвращение домой',
  full_step9_dur: '1-2 месяца после родов',
  full_step9_desc: 'Помощь в ДНК-тестировании, апостиле Гааги, визе и разрешении на выезд — полная поддержка для возвращения домой.',
  full_step9_p1: 'ДНК-тест на отцовство',
  full_step9_p2: 'Свидетельство + апостиль',
  full_step9_p3: 'Виза / разрешение на выезд',
  full_step9_p4: 'Полная поддержка репатриации',
  // Fertility pricing
  full_plan_economy: 'Эконом',
  full_plan_economy_badge: 'Бюджетный выбор',
  full_plan_economy_desc: 'Одна стимуляция, один перенос — оптимально при гладком процессе',
  full_plan_premium: 'Премиум',
  full_plan_premium_badge: 'Самый популярный',
  full_plan_premium_desc: 'Одна стимуляция, неограниченные переносы, компенсация рисков, подходит молодым клиентам',
  full_plan_comprehensive: 'Комплексный',
  full_plan_comprehensive_badge: 'Полная защита',
  full_plan_comprehensive_desc: 'Неограниченные стимуляции и переносы, для клиентов с потребностью в нескольких циклах',
  full_plan_btn: 'Получить детальную смету',
  full_plan_section_label: 'Тарифы',
  full_plan_section_title: 'Сравнение планов ЭКО + суррогатное',
  full_plan_section_sub: 'Три гибких плана для разных потребностей и бюджетов',
  full_plan_note_title: 'Примечания и включения',
  full_plan_note_inc_title: 'Обычно включено:',
  full_plan_note_extra_title: 'Возможные доп. расходы:',
  full_plan_note_footer: '* Справочные диапазоны. Фактическая стоимость зависит от выбора плана, медицинских условий и обменных курсов. Свяжитесь с консультантом для точной сметы. Комплексный план: неограниченные стимуляции действительны 1 год с даты первого забора.',
  full_plan_economy_item1: 'Одна стимуляция и забор',
  full_plan_economy_item2: 'ИКСИ',
  full_plan_economy_item3: 'Культивирование 5-7 дней',
  full_plan_economy_item4: 'ПГТ-А скрининг (8 эмбрионов)',
  full_plan_economy_item5: 'Один перенос за цикл',
  full_plan_economy_item6: 'Отбор и обследование сурматери',
  full_plan_economy_item7: 'Полное наблюдение беременности',
  full_plan_economy_item8: 'Лицензированный роддом, естественные роды',
  full_plan_economy_item9: 'Свидетельство + репатриация',
  full_plan_economy_item10: 'Криоконсервация 1 год',
  full_plan_premium_item1: 'Всё содержимое плана Эконом',
  full_plan_premium_item2: 'Неограниченные переносы за цикл',
  full_plan_premium_item3: 'Компенсация рисков беременности',
  full_plan_premium_item4: 'Персональное сопровождение родов',
  full_plan_premium_item5: 'Интерпретация всех отчётов',
  full_plan_premium_item6: 'Помощь в ДНК-тестировании',
  full_plan_premium_item7: 'Помощь с визой для возвращения',
  full_plan_premium_item8: 'Более распределённые платежи',
  full_plan_premium_item9: 'VIP медицинский консультант',
  full_plan_premium_item10: 'Экстренный медицинский план',
  full_plan_comp_item1: 'Всё содержимое плана Премиум',
  full_plan_comp_item2: 'Неограниченные стимуляции и заборы',
  full_plan_comp_item3: 'Неограниченные переносы',
  full_plan_comp_item4: 'Многоцикловый ПГТ-А скрининг',
  full_plan_comp_item5: 'Лекарства первых двух циклов включены',
  full_plan_comp_item6: 'Многоцикловая заморозка эмбрионов',
  full_plan_comp_item7: 'Страхование сурматери',
  full_plan_comp_item8: 'Профессиональный переводчик',
  full_plan_comp_item9: 'Неограниченные стимуляции 1 год',
  full_plan_comp_item10: 'Гарантия наивысшего успеха',
  full_plan_note_inc_item1: 'Консультация врача и разработка плана',
  full_plan_note_inc_item2: 'Стоимость лекарств для стимуляции (Кыргызстан)',
  full_plan_note_inc_item3: 'Забор яйцеклеток и анестезия',
  full_plan_note_inc_item4: 'Лабораторные расходы ИКСИ',
  full_plan_note_inc_item5: 'Культивирование и ПГТ-А скрининг',
  full_plan_note_inc_item6: 'Хирургия переноса эмбриона',
  full_plan_note_inc_item7: 'Управление отбором сурматери',
  full_plan_note_inc_item8: 'Медицинское наблюдение беременности',
  full_plan_note_inc_item9: 'Естественные роды и уход за новорождённым',
  full_plan_note_inc_item10: 'Юридические документы для репатриации',
  full_plan_note_extra_item1: 'Перелёт и проживание заказчика в Кыргызстане',
  full_plan_note_extra_item2: 'Оформление китайского паспорта и прописки',
  full_plan_note_extra_item3: 'Лекарства и мониторинг стимуляции (внутри страны)',
  full_plan_note_extra_item4: 'ПГТ-М генетический скрининг (опционально)',
  full_plan_note_extra_item5: 'Дополнительный ПГТ-А скрининг эмбрионов',
  full_plan_note_extra_item6: 'Дополнительная компенсация за двойню',
  full_plan_note_extra_item7: 'Дополнительная компенсация за кесарево',
  full_plan_note_extra_item8: 'Стоимость няни',
  // Services overview features
  svc_ivf_feature1: 'Удалённая + местная консультация',
  svc_ivf_feature2: 'Совместный план стимуляции',
  svc_ivf_feature3: 'ИКСИ',
  svc_ivf_feature4: 'Биопсия + ПГТ-А',
  svc_ivf_feature5: 'Скрининг 8 эмбрионов',
  svc_ivf_feature6: 'Криоконсервация 1 год',
  svc_surrogacy_feature1: 'Строгий отбор сурматери',
  svc_surrogacy_feature2: 'Полное наблюдение беременности',
  svc_surrogacy_feature3: 'Лицензированный роддом',
  svc_surrogacy_feature4: 'ДНК-тест на отцовство',
  svc_surrogacy_feature5: 'Свидетельство + виза',
  svc_surrogacy_feature6: 'Помощь с апостилем Гааги',
  svc_full_feature1: 'Полный процесс ЭКО + суррогатное',
  svc_full_feature2: 'Три гибких плана',
  svc_full_feature3: 'Неограниченные переносы (Премиум/Комплексный)',
  svc_full_feature4: 'Многоцикловая стимуляция (Комплексный)',
  svc_full_feature5: 'Компенсация рисков беременности',
  svc_full_feature6: 'Оформление документов для возвращения',

  // Common
  read_more: 'Читать далее',
  back: 'Назад',
  loading: 'Загрузка...',
  submit: 'Отправить',
  close: 'Закрыть',
  home: 'Главная',
  retry: 'Повторить',
};

export default common;